/**
 * Notifications Query Hooks
 *
 * TanStack Query hooks for notification-related data fetching
 */

import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/shared/stores/auth-store';
import { notificationsClient } from '../client/notifications.client';
import { queryKeys } from '../query-keys';

/**
 * Hook to fetch notifications list
 * Stale time: 30 seconds (real-time feel)
 * Only polls when the user has an active subscription (backend returns 403 otherwise)
 */
export function useNotifications() {
  const isSubscribed = useAuthStore((s) => s.isSubscribed);

  return useQuery({
    queryKey: queryKeys.notifications.list(),
    queryFn: () => notificationsClient.list(),
    staleTime: 1000 * 30, // 30 seconds
    refetchInterval: 1000 * 60, // Refetch every minute
    enabled: isSubscribed,
  });
}

/**
 * Hook to fetch notification contact preferences
 */
export function useNotificationPreferences() {
  return useQuery({
    queryKey: queryKeys.notifications.preferences(),
    queryFn: () => notificationsClient.getContactPreferences(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
